module.exports = __webpack_public_path__ + "img/m1_t1_bg.ce483411.svg";